"use strict";

var _classCallCheck = require("/app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/app/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/app/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/app/node_modules/@babel/runtime/helpers/getPrototypeOf");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LocalStorageHandler = void 0;

var types_1 = require("./types");

var Proxy_1 = __importDefault(require("./Proxy"));

var LocalStorageHandler = /*#__PURE__*/function (_Proxy_1$default) {
  _inherits(LocalStorageHandler, _Proxy_1$default);

  var _super = _createSuper(LocalStorageHandler);

  function LocalStorageHandler() {
    _classCallCheck(this, LocalStorageHandler);

    return _super.apply(this, arguments);
  }

  _createClass(LocalStorageHandler, [{
    key: "setSignInToken",
    value: function setSignInToken(token) {
      this.saveItem(types_1.LocalStorageItems.TOKEN, token);
    }
  }, {
    key: "setCsrfToken",
    value: function setCsrfToken(csrfToken) {
      this.saveItem(types_1.LocalStorageItems.CSRF_TOKEN, csrfToken);
    }
  }, {
    key: "setCheckout",
    value: function setCheckout(checkout) {
      this.saveObject(types_1.LocalStorageItems.CHECKOUT, checkout);
    }
  }, {
    key: "setPayment",
    value: function setPayment(payment) {
      this.saveObject(types_1.LocalStorageItems.PAYMENT, payment);
    }
  }, {
    key: "setJobs",
    value: function setJobs(jobs) {
      return this.saveObject(types_1.LocalStorageItems.JOB_QUEUE_CHECKOUT, jobs);
    }
  }, {
    key: "clear",
    value: function clear() {
      this.clearStorage();
    }
  }], [{
    key: "getCheckout",
    value: function getCheckout() {
      return Proxy_1.default.retrieveObject(types_1.LocalStorageItems.CHECKOUT);
    }
  }, {
    key: "getPayment",
    value: function getPayment() {
      return Proxy_1.default.retrieveObject(types_1.LocalStorageItems.PAYMENT);
    }
  }, {
    key: "getJobs",
    value: function getJobs() {
      return Proxy_1.default.retrieveObject(types_1.LocalStorageItems.JOB_QUEUE_CHECKOUT);
    }
  }, {
    key: "getSignInToken",
    value: function getSignInToken() {
      return Proxy_1.default.retrieveItem(types_1.LocalStorageItems.TOKEN);
    }
  }, {
    key: "getCsrfToken",
    value: function getCsrfToken() {
      return Proxy_1.default.retrieveItem(types_1.LocalStorageItems.CSRF_TOKEN);
    }
  }]);

  return LocalStorageHandler;
}(Proxy_1.default);

exports.LocalStorageHandler = LocalStorageHandler;